var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.editShow
    ? _c(
        "div",
        {
          staticClass: "editor parent_transform",
          class: [((_obj = {}), (_obj["edit"] = _vm.isEdit), _obj)],
          style: _vm.editStyle,
          attrs: { id: "editor" },
          on: { mousedown: _vm.handleMouseDown, scroll: _vm.canvasScroll },
        },
        [
          _vm.showPageLine
            ? _c("page-line-editor", {
                ref: "main-page-line",
                attrs: { "canvas-style-data": _vm.canvasStyleData },
              })
            : _vm._e(),
          _vm.showGrid
            ? _c("Grid", { attrs: { "matrix-style": _vm.matrixStyle } })
            : _vm._e(),
          _vm.psDebug
            ? _c("PGrid", {
                attrs: {
                  "position-box": _vm.positionBoxInfoArray,
                  "matrix-style": _vm.matrixStyle,
                },
              })
            : _vm._e(),
          _vm._l(_vm.componentData, function (item, index) {
            return _c(
              "de-drag",
              {
                key: item.id,
                ref: "deDragRef",
                refInFor: true,
                class: {
                  item: true,
                  moveAnimation: _vm.moveAnimate,
                  movingItem: item.isPlayer,
                },
                attrs: {
                  index: index,
                  "canvas-id": _vm.canvasId,
                  x: _vm.getShapeStyleIntDeDrag(item.style, "left"),
                  y: _vm.getShapeStyleIntDeDrag(item.style, "top"),
                  w: _vm.getShapeStyleIntDeDrag(item.style, "width", item),
                  h: _vm.getShapeStyleIntDeDrag(item.style, "height"),
                  r: item.style.rotate,
                  parent: _vm.parentForbid,
                  rotatable: _vm.rotatable,
                  "default-style": _vm.getShapeStyleInt(item.style),
                  active: item === _vm.curComponent,
                  element: item,
                  "class-name-active": "de-drag-active",
                  snap: true,
                  "snap-tolerance": 2,
                  "change-style": _vm.customStyle,
                  draggable: _vm.deDraggable,
                  resizable: _vm.deResizable,
                  "linkage-active": _vm.linkageActiveCheck(item),
                  "batch-opt-active": _vm.batchOptActiveCheck(item),
                },
                on: {
                  refLineParams: _vm.getRefLineParams,
                  showViewDetails: function ($event) {
                    return _vm.showViewDetails($event, index)
                  },
                  resizeView: function ($event) {
                    return _vm.resizeView(index, item)
                  },
                  onResizeStart: _vm.startResize,
                  onDragStart: _vm.onStartMove,
                  onHandleUp: _vm.onMouseUp,
                  onDragging: _vm.onDragging,
                  onResizing: _vm.onResizing,
                  elementMouseDown: _vm.containerMouseDown,
                  amRemoveItem: function ($event) {
                    return _vm.removeItem(item._dragId)
                  },
                  amAddItem: function ($event) {
                    return _vm.addItemBox(item)
                  },
                  canvasDragging: _vm.canvasDragging,
                  editComponent: function ($event) {
                    return _vm.editComponent(index, item)
                  },
                },
              },
              [
                _vm.renderOk && item.type === "custom"
                  ? _c("de-out-widget", {
                      ref: "wrapperChild",
                      refInFor: true,
                      staticClass: "component",
                      style: _vm.getComponentStyleDefault(item.style),
                      attrs: {
                        id: "component" + item.id,
                        "canvas-id": _vm.canvasId,
                        "prop-value": item.propValue,
                        element: item,
                        "is-relation":
                          _vm.searchButtonInfo &&
                          _vm.searchButtonInfo.buttonExist &&
                          _vm.searchButtonInfo.relationFilterIds.includes(
                            item.id
                          ),
                        "out-style": _vm.getShapeStyleInt(item.style),
                        active: item === _vm.curComponent,
                        h: _vm.getShapeStyleIntDeDrag(item.style, "height"),
                      },
                    })
                  : _vm.renderOk && item.type === "other"
                  ? _c(item.component, {
                      ref: "wrapperChild",
                      refInFor: true,
                      tag: "component",
                      staticClass: "component",
                      style: _vm.getComponentStyle(item.style),
                      attrs: {
                        id: "component" + item.id,
                        "canvas-id": _vm.canvasId,
                        "prop-value": item.propValue,
                        element: item,
                        "out-style": _vm.getShapeStyleInt(item.style),
                        active: item === _vm.curComponent,
                      },
                    })
                  : _vm.renderOk
                  ? _c(item.component, {
                      ref: "wrapperChild",
                      refInFor: true,
                      tag: "component",
                      staticClass: "component",
                      style: _vm.getComponentStyleDefault(item.style),
                      attrs: {
                        id: "component" + item.id,
                        "canvas-id": _vm.canvasId,
                        filters:
                          _vm.filterMap[
                            item.propValue && item.propValue.viewId
                          ],
                        "prop-value": item.propValue,
                        element: item,
                        "out-style": _vm.getShapeStyleInt(item.style),
                        active: item === _vm.curComponent,
                        "edit-mode": "edit",
                        h: _vm.getShapeStyleIntDeDrag(item.style, "height"),
                        "canvas-style-data": _vm.canvasStyleData,
                      },
                      on: {
                        input: _vm.handleInput,
                        "trigger-plugin-edit": _vm.pluginEditHandler,
                        "fill-chart-2-parent": _vm.setChartData,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          _vm.shadowShow && _vm.dragShadowShow
            ? _c("drag-shadow", { attrs: { "canvas-id": _vm.canvasId } })
            : _vm._e(),
          _vm.pointShadowShow
            ? _c("point-shadow", { attrs: { "canvas-id": _vm.canvasId } })
            : _vm._e(),
          _c("ContextMenu"),
          _vm._l(_vm.vLine, function (item, index) {
            return _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: item.display,
                  expression: "item.display",
                },
              ],
              key: "v_" + index,
              staticClass: "ref-line v-line",
              style: {
                left: item.position,
                top: item.origin,
                height: item.lineLength,
              },
            })
          }),
          _vm._l(_vm.hLine, function (item, index) {
            return _c("span", {
              key: "h_" + index,
              staticClass: "ref-line h-line",
              style: {
                top: item.position,
                left: item.origin,
                width: item.lineLength,
              },
            })
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }